
import angular from 'angular';


const controllerInfo = {
    module: 'ib-ancillaries-modal-module',
    inject: ['$uibModalInstance', 'object', '$filter'],
    required: []
};

export class ModalBundelingMoreInfoController implements ng.IController {

    public model;
    public baggageCheckUp;
    public speqsCheckUp;
    translationsWithBoldStyle: any;
    constructor (
        private $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
        private object: any,
        private $filter: ng.FilterFactory) {
        this.model = object;
    }

    $onInit (): void {
        this.model.itemsInBundle.forEach(item => {
            if(item.type === 'BAGGAGE') {
                this.baggageCheckUp = this.$filter('translate')('BUNDLE_MORE_INFO_BAGGAGES_NEW_CHECK_UP');
                switch (item.subtype) {
                        case 'BAGGAGE_15':
                            this.baggageCheckUp = this.baggageCheckUp.replace('#', '15');
                            break;
                        case 'BAGGAGE_23':
                            this.baggageCheckUp = this.baggageCheckUp.replace('#', '23');
                            break;
                        case 'BAGGAGE_32':
                            this.baggageCheckUp = this.baggageCheckUp.replace('#', '32');
                            break;
                }
            }
            if(item.type === 'SPECIAL_EQUIPMENT') {
                this.speqsCheckUp = this.$filter('translate')('BUNDLE_MORE_INFO_SPEQS_CHECK_UP');
                this.speqsCheckUp = this.speqsCheckUp.replace('#', item.quantityPassAndTrips);
                /*
                switch (item.subtype) {
                    case 'SKI_SNOW':
                        this.speqsCheckUp = this.speqsCheckUp.replace('#', this.$filter('translate')('SPEQS_SKI_SNOW').toLowerCase());
                        break;
                    case 'GOLF_EQUIPMENT':
                        this.speqsCheckUp = this.speqsCheckUp.replace('#', this.$filter('translate')('SPEQS_GOLF_EQUIPMENT').toLowerCase());
                        break;
                    case 'FISHING_EQUIPMENT':
                        this.speqsCheckUp = this.speqsCheckUp.replace('#', this.$filter('translate')('SPEQS_MODULE_TITLE').toLowerCase());
                        break;
                    case 'SCUBA_DIVING':
                        this.speqsCheckUp = this.speqsCheckUp.replace('#', this.$filter('translate')('SPEQS_MODULE_TITLE').toLowerCase());
                        break;
                    case 'SURFBOARD':
                        this.speqsCheckUp = this.speqsCheckUp.replace('#', this.$filter('translate')('SPEQS_MODULE_TITLE').toLowerCase());
                        break;
                    case 'BICYCLE':
                        this.speqsCheckUp = this.speqsCheckUp.replace('#', this.$filter('translate')('SPEQS_BICYCLE').toLowerCase());
                        break;
                    case 'SPORTING_FIREARMS':
                        this.speqsCheckUp = this.speqsCheckUp.replace('#', this.$filter('translate')('SPEQS_MODULE_TITLE').toLowerCase());
                        break;
                }*/
            }
        });

        this.translationsWithBoldStyle = this.buildLitAndHtml();
    }

    buildLitAndHtml () {
        const tagsInfo = {
            bold: {
                tag: 'span',
                class: 'ib-text--bold-gray'
            }
        };
        const LITERALS = {
            ANCILLARIES_FLEXIBILITY_FLIGHT_CHANGE_BODY_1: 'ANCILLARIES_FLEXIBILITY_FLIGHT_CHANGE_BODY_1',
            ANCILLARIES_FLEXIBILITY_PACK_FLEXIBILITY_LONG_RATIO_BODY_1: 'ANCILLARIES_FLEXIBILITY_PACK_FLEXIBILITY_LONG_RATIO_BODY_1',
            ANCILLARIES_FLEXIBILITY_PACK_FLEXIBILITY_LONG_RATIO_BODY_2: 'ANCILLARIES_FLEXIBILITY_PACK_FLEXIBILITY_LONG_RATIO_BODY_2',
            ANCILLARIES_FLEXIBILITY_PACK_FLEXIBILITY_SHORT_RATIO_BODY_1: 'ANCILLARIES_FLEXIBILITY_PACK_FLEXIBILITY_SHORT_RATIO_BODY_1',
            ANCILLARIES_FLEXIBILITY_PACK_FLEXIBILITY_SHORT_RATIO_BODY_2: 'ANCILLARIES_FLEXIBILITY_PACK_FLEXIBILITY_SHORT_RATIO_BODY_2',
            ANCILLARIES_FLEXIBILITY_VOUCHER_PARTIAL_REFUND_BODY_1: 'ANCILLARIES_FLEXIBILITY_VOUCHER_PARTIAL_REFUND_BODY_1',
            ANCILLARIES_FLEXIBILITY_VOUCHER_TOTAL_REFUND_BODY_1: 'ANCILLARIES_FLEXIBILITY_VOUCHER_TOTAL_REFUND_BODY_1'
        };
        const result = [];

        Object.keys(LITERALS).forEach((key: string) => {
            result.push(this.$filter('literalFormatter')(this.$filter('translate')(LITERALS[key]), tagsInfo));
        });

        return result;
    }
    /**
        * Close modal
        */
    close = (): void => {
        angular.element(document).find('.modal').eq(0).removeClass('ib-modals--right');
        this.$uibModalInstance.dismiss('cancel');
    };
}


try {
    ModalBundelingMoreInfoController.$inject = controllerInfo.inject;
    angular.module(controllerInfo.module).controller(ModalBundelingMoreInfoController.name, ModalBundelingMoreInfoController);

} catch (error) {
    const mod = angular.module(controllerInfo.module, controllerInfo.required);
    ModalBundelingMoreInfoController.$inject = controllerInfo.inject;
    mod.controller(ModalBundelingMoreInfoController.name, ModalBundelingMoreInfoController);
}